import React, { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import CircleRoundedIcon from '@mui/icons-material/CircleRounded';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineContent from '@mui/lab/TimelineContent';
import { LATEST_AVAILABLE_YEAR, EARLIEST_AVAILABLE_YEAR } from '../../constants';
import './SelectTimeline.scss'
import { Stepper, Step, StepLabel, StepConnector } from '@mui/material';
import styled from '@mui/material/styles/styled';


function SelectTimeline(props) {
    const [years, setYears] = useState([])
    const [selectedTimeline, setSelectedTimeline] = useState(EARLIEST_AVAILABLE_YEAR)
    const data = require('./../../assets/data/data.json') || props.gameData
    const uniqueYears = [...new Set(data.map(entry => entry.Election))];

    useEffect(() => {
        let newYears = []
        for (let year = EARLIEST_AVAILABLE_YEAR; year <= LATEST_AVAILABLE_YEAR; year += 4) {
            newYears.push(year)
        }
        setYears(newYears)
    }, [])

    const timelineStyle = {
        // transform: "rotate(-90deg)",
        // height: '90px',
        alignItems: 'center',
        justifyContent: 'center'
    }

    const timelineContentContainerStyle = {
        textAlign: "left",
        paddingLeft: '10px',
        fontSize: '15px'
    }

    const timelineBoldContentContainerStyle = {
        textAlign: "left",
        fontWeight: "bold",
        paddingLeft: '10px',
        fontSize: '15px'
    }

    const timelineContentStyle = {
        textAlign: "center",
        fontSize: '11pt',
        fontWeight: 'bold',
    }

    const timelineItemStyle = {
        minHeight: '45px',
        margin: 0,
    }

    const timelineRedDotStyle = {
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        color: '#B2292D',
        margin: '6px 0',
        fontSize: '24px'
    }

    const timelineSelectedDotStyle = {
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        color: '#5B6586',
        margin: '6px 0',
        fontSize: '24px'
    }

    const iconContainer = {
        padding: 0,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
    }

    const timelineDotStyle = {
        margin: '6px 0',
        color: '#E7DCDA',
        fontSize: '24px'
    }

    function handleChange(year) {
        setSelectedTimeline(year)
        props.handleChange(year)
    }
    const QontoConnector = styled(StepConnector)(({ theme }) => ({
        '&.MuiStepConnector-root': {
            left: 'calc(-50% + 20px)',
            right: 'calc(50% + 20px)',
            top: '15px',
        },
        '& .MuiStepConnector-line': {
            borderRadius: 1,
        },
    }));


    return (
        <div style={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
            <Stepper alternativeLabel connector={<QontoConnector />}>
                {years.map((year, index) => (
                    <Step key={index} completed={uniqueYears.includes(year)}>
                        <StepLabel
                            icon={uniqueYears.includes(year) ?
                                <IconButton aria-label='year-selector-button'  className='icon-button' sx={iconContainer} size='small' onClick={() => handleChange(year)}>
                                    {selectedTimeline === year ?
                                        <CircleRoundedIcon sx={timelineSelectedDotStyle} />
                                        :
                                        <CircleRoundedIcon sx={timelineRedDotStyle} />
                                    }

                                </IconButton>
                                :
                                <IconButton className='icon-button' sx={iconContainer} size='small' disabled={true}>
                                    <CircleRoundedIcon sx={timelineDotStyle} />
                                </IconButton>}>
                            <div style={timelineContentStyle}>{year}</div>
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </div >
    );
}

export default SelectTimeline;
